export const AI_USAGE_SERVICE_NAME = "物件管理";

interface ClientService {
  service?: {
    id?: string | null;
    name?: string | null;
  } | null;
}

export const canAccessAiUsage = (
  accountRole: string | null,
  clientServices: ClientService[] | null | undefined,
): boolean =>
  accountRole === "owner" &&
  (clientServices ?? []).some(
    ({ service }) => service?.name === AI_USAGE_SERVICE_NAME,
  );
